import { render, staticRenderFns } from "./ProductLittle.vue?vue&type=template&id=06b827ba&"
import script from "./ProductLittle.vue?vue&type=script&lang=js&"
export * from "./ProductLittle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports